import React, { useState, useEffect } from "react";

const Statistics = ({ stats = [] }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const colors = ["#1A81BA", "#2E6195", "#5AA650", "#1D6043", "#3F4E9E"];
  const safeStats = (stats || []).slice(0, 3);

  useEffect(() => {
    if (!safeStats.length) return;
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % safeStats.length);
    }, 3000);
    return () => clearInterval(interval);
  }, [safeStats.length]);

  if (!safeStats.length) return null;

  const currentStat = safeStats[currentIndex] || { value: "", label: "" };
  const currentColor = colors[currentIndex % colors.length];

  return (
    <section className="py-12 sm:py-10 px-4 bg-gradient-to-br from-gray-50 to-white">
      <div className="container mx-auto max-w-7xl">
        <div className="bg-gradient-to-br from-blue-50 via-green-50 to-blue-50 rounded-3xl shadow-xl p-8 lg:p-12">
          
          {/* Desktop  */}
          <div className="hidden lg:grid lg:grid-cols-3 gap-8 lg:gap-12">
            {safeStats.map((stat, index) => {
              const color = colors[index % colors.length];
              return (
                <div key={index} className="text-center">
                  <h3
                    className="text-2xl sm:text-3xl font-bold mb-2"
                    style={{ color }}
                  >
                    {stat.value}
                  </h3>
                  <p className="text-gray-600 uppercase text-xs sm:text-sm font-medium">
                    {stat.label}
                  </p>
                </div>
              );
            })}
          </div>

          {/* Mobile + Tablet */}
          <div className="lg:hidden">
            <div className="text-center min-h-[80px] sm:min-h-[90px] flex flex-col items-center justify-center">
              <h3
                className="text-2xl sm:text-3xl font-bold mb-1 transition-all duration-500"
                style={{ color: currentColor }}
              >
                {currentStat.value}
              </h3>
              <p className="text-gray-600 uppercase text-[14px] sm:text-sm font-medium transition-all duration-500">
                {currentStat.label}
              </p>
            </div>

            {/* Dots */}
            <div className="flex justify-center gap-2 mt-4 sm:mt-5">
              {safeStats.map((_, index) => {
                const color = colors[index % colors.length];
                const isActive = index === currentIndex;
                return (
                  <button
                    key={index}
                    onClick={() => setCurrentIndex(index)}
                    className={`relative rounded-full transition-all duration-500 ${
                      isActive ? "w-5 h-2 shadow-md" : "w-2 h-2 hover:scale-110"
                    }`}
                    style={{
                      backgroundColor: isActive ? color : "#CBD5E1",
                    }}
                    aria-label={`Go to stat ${index + 1}`}
                    type="button"
                  >
                    {isActive && (
                      <span
                        className="absolute inset-0 rounded-full animate-pulse opacity-50"
                        style={{ backgroundColor: color }}
                      />
                    )}
                  </button>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Statistics;
